import { message } from "antd";
import React, { useState } from "react";
import { UseLazyApiCallPerformanceGolf } from "hooks";

export const UseDownloadJsonBundle = () => {
  const [downloading, setDownloading] = useState(false);

  const [downloadJson, { isLoading: jsonLoading, error: jsonError }] =
    UseLazyApiCallPerformanceGolf({
      url: "/api/downloads/json",
      method: "POST",
    }) as any;

  const [
    downloadJsonWithVideo,
    { isLoading: jsonWithVideoLoading, error: jsonVideoError },
  ] = UseLazyApiCallPerformanceGolf({
    url: "/api/downloads/video",
    method: "POST",
  }) as any;

  async function handleDownloadJson({
    fileId,
    type,
  }: {
    fileId: string;
    type: string;
  }) {
    if (!fileId) return;

    setDownloading(true);
    try {
      let downloadRes;

      if (type === "video") {
        downloadRes = await downloadJsonWithVideo({
          params: { id: fileId, mode: "download" },
        });

        if (!downloadRes?.url) {
          throw new Error("Download URL missing");
        }

        const link = document.createElement("a");
        link.href = downloadRes?.url;
        link.download = downloadRes?.filename || "video.mp4";
        document.body.appendChild(link);
        link.click();
        link.remove();

        message.success("Downloaded successfully...");
      } else {
        downloadRes = await downloadJson({
          params: { id: fileId, type },
        });

        if (!downloadRes) {
          throw new Error(jsonError);
        }

        const blob = new Blob([JSON.stringify(downloadRes, null, 2)], {
          type: "application/json",
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "file.json"; // Adjust as needed
        document.body.appendChild(link);
        link.click();
        link.remove();
        message.success("Downloaded successfully...");
      }
    } catch (error: any) {
      console.error(error);
      message.error(error?.message || "Something went wrong");
    } finally {
      setDownloading(false);
    }
  }

  return { downloading, handleDownloadJson };
};
